
import { BrowserRouter, useLocation } from 'react-router-dom'
import { AppRoutes } from './router'
import ScrollToTop from './components/base/ScrollToTop'
import { useEffect } from 'react'

function RouteScrollReset() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function RevealObserver() {
  const { pathname } = useLocation()

  useEffect(() => {
    const selectors = '.reveal, .reveal-left, .reveal-right, .reveal-children'

    const observe = () => {
      const els = document.querySelectorAll<HTMLElement>(selectors)
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed')
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.1 }
      )
      els.forEach((el) => observer.observe(el))
      return observer
    }

    // Small delay to let React finish rendering the new route
    const timer = setTimeout(() => {
      const observer = observe()
      return () => observer.disconnect()
    }, 50)

    return () => clearTimeout(timer)
  }, [pathname])

  return null
}

function App() {
  return (
    <BrowserRouter basename="/">
      <RouteScrollReset />
      <RevealObserver />
      <AppRoutes />
      <ScrollToTop />
    </BrowserRouter>
  )
}

export default App
